import React from "react";

const TypingMessage = () => {
    return <div className="message typing">
        <span className="dot"/>
        <span className="dot"/>
        <span className="dot"/>
    </div>
}

export default TypingMessage;
